export const getUserToken = () => {
    return localStorage.getItem('user_token') || "";
};